import { ENDPOINT } from '../globals/endpoint';
import { apiHelper } from '../helpers/api-helper';
import { FindApprovalInfo } from '../globals/find-approval-info';
import { CreateApplicationReturn } from './create-application';

export const findApproval = async (approvalInfo: FindApprovalInfo): Promise<CreateApplicationReturn> => {
  const endpoint = ENDPOINT.FindApproval;

  const response = await apiHelper(endpoint, {
    method: 'POST',
    body: JSON.stringify(approvalInfo),
  });

  const resp = await response.json();

  return response ? resp : void 0;
};
